export type ViewAs = { kind: "user" | "role"; id: string; label: string };

const KEY = "signet:view-as";

export function currentViewAs(): ViewAs | null {
  try {
    const value = sessionStorage.getItem(KEY);
    if (!value) return null;
    const parsed = JSON.parse(value) as Partial<ViewAs>;
    return (parsed.kind === "user" || parsed.kind === "role") && typeof parsed.id === "string" && typeof parsed.label === "string"
      ? parsed as ViewAs
      : null;
  } catch {
    return null;
  }
}

export function startViewAs(view: ViewAs): void {
  sessionStorage.setItem(KEY, JSON.stringify(view));
  location.assign("/");
}

export function stopViewAs(): void {
  sessionStorage.removeItem(KEY);
  location.reload();
}
